var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndTripError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.217 22.9986C45.217 35.2716 35.2678 45.2208 22.9948 45.2208C10.7218 45.2208 0.772583 35.2716 0.772583 22.9986C0.772583 10.7256 10.7218 0.776367 22.9948 0.776367C35.2678 0.776367 45.217 10.7256 45.217 22.9986ZM16.2606 16.2645C16.9115 15.6136 17.9668 15.6136 18.6177 16.2645L22.9947 20.6415L27.3718 16.2645C28.0226 15.6137 29.0779 15.6137 29.7288 16.2645C30.3797 16.9154 30.3797 17.9707 29.7288 18.6215L25.3518 22.9986L29.7287 27.3755C30.3796 28.0264 30.3796 29.0817 29.7287 29.7326C29.0779 30.3834 28.0226 30.3834 27.3717 29.7326L22.9947 25.3556L18.6177 29.7326C17.9668 30.3835 16.9116 30.3835 16.2607 29.7326C15.6098 29.0817 15.6098 28.0265 16.2607 27.3756L20.6377 22.9986L16.2606 18.6215C15.6098 17.9706 15.6098 16.9154 16.2606 16.2645Z",
    fill: "#E31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndTripError);
export default __webpack_public_path__ + "static/media/endTripError.91fad6f78b4f685f559c399c0c28e96e.svg";
export { ForwardRef as ReactComponent };